import {PolyDictionary} from '../../../../../../../@polygonjs/polygonjs/src/types/GlobalTypes';
import {Ref} from 'vue';

export class BaseCodeDisplayer {
	static clear(shadersByName: Ref<PolyDictionary<string | null>>, shaderNames: Ref<string[]>) {
		shaderNames.value.splice(0, shaderNames.value.length);
		const namesInShaderByName = Object.keys(shadersByName.value);
		for (let shaderName of namesInShaderByName) {
			delete shadersByName.value[shaderName];
		}
	}
}
